import React from 'react'
import { Create, SimpleForm, TextInput, useTranslate } from 'react-admin'
import { Paper, Container } from '@mui/material'

export const HotelDetailCreate = (props) => {
  const translate = useTranslate()
  return (
    <>
      <Container className='content'>
        <Paper className='paper_content'>
          <Create title='Create a Business Type' {...props}>
            <SimpleForm>
              <TextInput source='hotel_name' label='hotel name' />
              <TextInput source='date_out' label={translate('ra.field.date_out')} />
              <TextInput source='date_in' label={translate('ra.field.date_in')} />
              <TextInput source='item_id' label='item id' />
            </SimpleForm>
          </Create>
        </Paper>
      </Container>
    </>
  )
}
